<template lang="pug">
    .settings(v-if='settings')
        template(v-if="parametersFrom === 'homework'")
            span(v-if="settings.mode")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}: {{ getModeName(settings.mode) }}
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
            | {{ settings.amountOfExamples }}
            br
            template(v-if="settings.timeForAnswer != '-1'")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}:
                | {{ settings.timeForAnswer }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
                br
            template(v-if='settings.numbers && settings.numbers.length !== 0')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}: {{ settings.numbers.join(', ') }}
                br
                template(v-if='settings.digitCapacity && settings.digitCapacity.right.length > 0')
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}:
                    | {{ settings.digitCapacity.right.join() }}
                    br
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_tableValue') }}:
                    template(v-if='settings.tabulatedValue')
                        | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                    template(v-else)
                        | {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
                br
            template(v-else-if='settings.digitCapacity')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}:
                | {{ digitCapacity[settings.digitCapacity.left.join()] }}
                br
                | {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}:
                | {{ dividerMultiplier }}
                template(v-if='settings.fractions && settings.fractions.left')
                    br
                    span
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}:
                        | {{ getFractionalPart('left') }}
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_afterPoint') }}
                    br
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}:
                    | {{ digitCapacity[settings.digitCapacity.right.join()] }}
                template(v-if='settings.fractions && settings.fractions.right')
                    br
                    span
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}:
                        | {{ getFractionalPart('right') }}
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_afterPoint') }}
                template(v-if='settings.divMode')
                    br
                    span
                        | {{ $i18n.t('trainer.trainer_gameFormSettingDivision_mode') }}:
                        | {{ $i18n.t(`trainer.trainer_gameFormSettingDivision_${settings.divMode}`) }}
                template(v-if='settings.remainder')
                    br
                    span
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_remainder') }}:
                        | {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
                br
        template(v-else)
            template(v-if='settings.numbers.length > 0')
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numbers') }}: {{ settings.numbers.join(', ') }}
                br
                | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}:
                template(v-for='number in settings.digitCapacity.right')
                    | {{ digitCapacity[number] }}
                br
                | {{ $i18n.t('trainer.trainer_gameFormSetting_tableValue') }}:
                template(v-if='settings.tabulatedValue')
                    | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                template(v-else)
                    | {{ $i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') }}
                br
            template(v-else)
                | {{ $i18n.t('trainer.trainer_gameFormSetting_divisibleMultiplier') }}:
                template(v-for='number in settings.digitCapacity.left')
                    | {{ digitCapacity[number] }}
                span(v-if='settings.fractions && settings.fractions.left')
                    br
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}:
                    | {{ getFractionalPart('left') }}
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_afterPoint') }}
                    br
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dividerMultiplier') }}:
                template(v-for='number in settings.digitCapacity.right')
                    | {{ digitCapacity[number] }}
                template(v-if='settings.remainder')
                    span
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_remainder') }}:
                        | {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
                span(v-if='settings.fractions && settings.fractions.right')
                    br
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}:
                    | {{ getFractionalPart('right') }}
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_afterPoint') }}
                br
        | {{ $i18n.t('trainer.trainer_gameFormSetting_operations') }}: {{ field('operations') }}
        template(v-if="areExtraOperationsEnabled")
            br
            | {{ $i18n.t('trainer.trainer_gameFormSetting_extraOperations') }}: {{ field('extraOperations') }}
        br
        slot
</template>

<script>
    import preview from '../../../utils/multiplication-and-division/preview';

    export default {
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
            userId: Number,
        },
        mixins: [preview],
        methods: {
            getFractionalPart(side) {
                return (
                    this.settings.fractionalPart[side] +
                    ' ' +
                    this.$i18n.tc('trainer.trainer_gamePreview_numDeclination', this.settings.fractionalPart[side])
                );
            },
        },
    };
</script>
